import Vue from "vue";
import users from "../users";
import * as utils from "../utils";
import axios from "axios";
import jwtTokenHandler from "@/jwtTokenHandler";

export default {
  name: "EmployeeHome_Dashboard",
  components: {
    dashboardComp: require("./dashboards.vue").default,
    NotificationBannerComp:
      require("@/components/notificationBanner/notificationBanner.vue").default,
  },
  mixins: [users, jwtTokenHandler],
  data: function () {
    return {
      managementDashboards: false,
      brandingSecondaryColor: "",
      brandingSecondaryColorBack: "",
      showPermissionDialog: false,
      isMobileOs: false,
      vidPermission: false,
      locPermission: false,
      timer: null,
      menuItems: [],
      menuItemsBCRM: [],
      menuItemseFWM: [],
      menuItemsMMS: [],
      menuItemsBCRMChecked: false,
      menuItemseFWMChecked: false,
      menuItemsMMSChecked: false,
      bCRMCounter: 0,
      eFWMCounter: 0,
      MMSCounter: 0,
      dashboardKey: 0,
      allowDashboards: false,
      message: "",
      portalNewCs: false,
      portalOm: false,
      portalDisconnections: false,
      portalDm: false,
      portalDmControlPanel: false,
      portalElements: false,
      portalAssetRegister: false,
      portalLogs: false,
      portalQuality: false,
      portalCaptureMeterReadings: false,
      portalGis: false,
      portalGisAdmin: false,
      portalReceiping: false,
      portalReceipingSessions: false,
      portalEnquiries: false,
      portalMaintenanceCrm: false,
      portalBilling: false,
      portalConditionAssessment: false,
      portalDmAgreements: false,
      portalCmrAdmin: false,

      isFieldWorker: false,
    };
  },
  computed: {
    dashboardOptionsObj: function () {
      return {
        bcrm: this.menuItemsBCRMChecked,
        fwm: this.menuItemseFWMChecked,
        mms: this.menuItemsMMSChecked,
      };
    },
    permissionsAreMissing: function () {
      return this.vidPermission == false || this.locPermission == false;
    },
    errorText: function () {
      let vidPerm = !this.vidPermission ? this.$t("common.Geolocation") : "";
      let locPerm = !this.locPermission ? this.$t("common.Camera") : "";
      let descr = "";

      descr = descr + vidPerm;

      if (locPerm) {
        if (vidPerm) descr = descr + ", " + locPerm;
        else descr = descr + locPerm;
      }

      return (
        this.$t("common.disabledPermissions1") +
        descr +
        this.$t("common.disabledPermissions2")
      );
    },
  },
  async created() {
    await this.getProfileDetails();
    this.getSettings();
    //console.log("data", this);
    //this.manageOpenGroup();
  },
  mounted() {
    this.askForPermissions();

    let temp = this.$localStorage.get("brandingSecondaryColor");
    if (temp) {
      this.brandingSecondaryColor = `color: ${temp} !important;`;
      this.brandingSecondaryColorBack = `background-color: ${temp} !important;`;
    }
  },
  beforeRouteLeave(to, from, next) {
    this.saveFilterToLocal();
    next();
  },
  methods: {
    openDashboards() {
      this.$router.push("/dashboards");
    },
    isMobileDeviceCheck() {
      //Storing user's device details in a variable
      let details = navigator.userAgent;

      //Creating a regular expression containing some mobile devices keywords to search it in details string
      let regexp = /android|iphone|kindle|ipad/i;

      //Using test() method to search regexp in details it returns boolean value
      this.isMobileOs = regexp.test(details);
      return this.isMobileOs;
    },
    askForPermissions() {
      if (this.isMobileDeviceCheck()) {
        this.geoLocPermission = false;

        navigator.permissions.query({ name: "camera" }).then((respCam) => {
          //console.log("camera", respCam)
          if (respCam.state != "granted") {
            this.showPermissionDialog = true;
            navigator.mediaDevices
              .getUserMedia({ video: true })
              .then((resp) => {
                this.vidPermission = true;
              })
              .catch((err) => (this.vidPermission = false));
          } else {
            this.vidPermission = true;
          }

          navigator.permissions
            .query({ name: "geolocation" })
            .then((respGeo) => {
              //console.log("geolocation", respGeo)
              if (respGeo.state != "granted") {
                this.showPermissionDialog = true;
                navigator.geolocation.getCurrentPosition(
                  (pos) => {
                    this.locPermission = true;
                    if (this.locPermission && this.vidPermission)
                      this.showPermissionDialog = false;
                  },
                  (err) => {
                    this.locPermission = false;
                  }
                );
              } else {
                this.locPermission = true;
              }
            })
            .finally(() => {});
        });
      }
    },
    getSettings() {
      axios
        .post("/Utility/GetSettings")
        .then((response) => {
          if (response.data.data.status == 0) {
            this.allowDashboards = this.isFieldWorker
              ? false
              : this.managementDashboards &&
                response.data.value.allowDashboardsEmployee;
          }
        })
        .catch((e) => {
          this.$parent.user.authenticated = false;
          this.$router.push("/login");
        });
    },
    async getProfileDetails() {
      return await axios
        .post("/account/GetProfileDetails")
        .then((response) => {
          if (response.data.data.status == 0) {
            //add flag for field worker user
            //this.user['isFieldWorker'] = response.data.item.isFieldWorker;
            this.isFieldWorker = response.data.item.isFieldWorker;
            this.managementDashboards = response.data.item.managementDashboards;

            var resp = response.data.item;
            this.portalNewCs =
              resp.portalNewCs && resp.portalNewCs == true ? true : false;
            this.portalOm =
              resp.portalOm && resp.portalOm == true ? true : false;
            this.portalDisconnections =
              resp.portalDisconnections && resp.portalDisconnections == true
                ? true
                : false;
            this.portalDm =
              resp.portalDm && resp.portalDm == true ? true : false;
            this.portalDmControlPanel =
              resp.dmControlPanel && resp.dmControlPanel == true ? true : false;
            this.portalElements =
              resp.elementProperties && resp.elementProperties == true
                ? true
                : false;
            this.portalAssetRegister =
              resp.assetRegister && resp.assetRegister == true ? true : false;
            this.portalConditionAssessment =
              resp.conditionAssessment && resp.conditionAssessment == true
                ? true
                : false;
            this.portalLogs =
              resp.portalLogs && resp.portalLogs == true ? true : false;
            this.portalQuality =
              resp.portalQuality && resp.portalQuality == true ? true : false;
            this.portalCmrAdmin =
              resp.portalCaptureMeterReadingsAdmin &&
              resp.portalCaptureMeterReadingsAdmin == true
                ? true
                : false;
            if (this.portalCmrAdmin == true)
              this.portalCaptureMeterReadings = false;
            else
              this.portalCaptureMeterReadings =
                resp.portalCaptureMeterReadings &&
                resp.portalCaptureMeterReadings == true
                  ? true
                  : false;
            this.portalGis =
              resp.portalGis && resp.portalGis == true ? true : false;
            this.portalGisAdmin =
              resp.portalGisAdmin && resp.portalGisAdmin == true ? true : false;
            this.portalReceiping =
              resp.portalReceiping && resp.portalReceiping == true
                ? true
                : false;
            this.portalReceipingSessions =
              resp.portalReceipingSessions &&
              resp.portalReceipingSessions == true
                ? true
                : false;
            this.portalEnquiries = !resp.isFieldWorker;
            this.portalMaintenanceCrm =
              resp.portalMaintenanceCrm && resp.portalMaintenanceCrm == true
                ? true
                : false;
            this.portalBilling =
              resp.billing && resp.billing == true ? true : false;
            this.portalDmAgreements =
              resp.portalDmAgreements && resp.portalDmAgreements == true
                ? true
                : false;

            var user = { role: resp.role, authenticated: true };
            this.menuItems = utils.getMenuItems(user, this.roles);
            this.menuItems.shift();

            if (this.portalNewCs == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "applications"
              );
              //this.menuItems = this.menuItems.filter(item => item.id != 'enquiries');
            }
            if (
              this.isFieldWorker ||
              (!this.isFieldWorker &&
                !this.portalNewCs &&
                !this.portalDisconnections &&
                !this.portalCmrAdmin &&
                !this.portalDmAgreements &&
                !this.portalReceiping &&
                !this.portalReceipingSessions &&
                !this.portalBilling &&
                !this.portalDmControlPanel &&
                !this.portalCaptureMeterReadingsAdmin)
            ) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "enquiries"
              );
            }
            if (this.portalOm == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "omApplications"
              );
            }
            if (this.portalDisconnections == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "disconnections"
              );
            }
            if (this.portalDm == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.name != "Dm"
              );
            }
            if (this.portalDmControlPanel == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "dmControlPanel"
              );
            }
            if (this.portalElements == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "elements"
              );
            }
            if (this.portalAssetRegister == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "assets"
              );
            }
            if (this.portalConditionAssessment == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "conditionAssessment"
              );
            }
            if (this.portalLogs == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "logs"
              );
            }
            if (this.portalQuality == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "samples"
              );
            }
            if (this.portalCaptureMeterReadings == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "captureMeterReadings"
              );
            }
            if (this.portalGis == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "webgis"
              );
            }
            if (this.portalGisAdmin == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "gisAdministration"
              );
            }

            if (this.portalReceiping == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "receipting"
              );
            }
            if (this.portalReceipingSessions == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "sessions"
              );
            }
            if (this.portalMaintenanceCrm == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "omActivities"
              );
            }
            if (this.portalBilling == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "billing"
              );
            }
            if (this.portalDmAgreements == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "agreements"
              );
            }
            if (this.portalCmrAdmin == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "cmrAdmin"
              );
            }

            /* Applications Grouping */
            for (let i = 0; i < this.menuItems.length; i++) {
              if (this.menuItems[i].id == "omActivities") {
                this.MMSCounter++;
                this.menuItemsMMS.push(this.menuItems[i]);
              }
              if (
                this.menuItems[i].id == "omApplications" ||
                this.menuItems[i].id == "assets" ||
                this.menuItems[i].id == "conditionAssessment" ||
                this.menuItems[i].id == "logs" ||
                this.menuItems[i].id == "samples" ||
                this.menuItems[i].id == "captureFieldElements"
              ) {
                //GROUP eFWM
                this.eFWMCounter++;
                this.menuItemseFWM.push(this.menuItems[i]);
              }
              if (
                this.menuItems[i].id == "applications" ||
                this.menuItems[i].id == "enquiries" ||
                this.menuItems[i].id == "disconnections" ||
                this.menuItems[i].id == "receipting" ||
                this.menuItems[i].id == "sessions" ||
                this.menuItems[i].id == "agreements" ||
                this.menuItems[i].id == "billing" ||
                this.menuItems[i].id == "dmControlPanel" ||
                this.menuItems[i].id == "cmrAdmin" ||
                this.menuItems[i].id == "captureMeterReadings"
              ) {
                //GROUP eFWM
                this.bCRMCounter++;
                this.menuItemsBCRM.push(this.menuItems[i]);
              }

              if (this.menuItems[i].name == "Dm") {
                //change in app.ts L568, dashboards.ts L294 and dms.ts L250
                if (this.isFieldWorker == true)
                  this.menuItems[i].id = "debtManagementSelectBatch";
                this.bCRMCounter++;
                this.menuItemsBCRM.push(this.menuItems[i]);
              }
            }

            Vue.nextTick(() => {
              this.manageOpenGroup();
              return true;
            });
          } else {
            this.$parent.user.authenticated = false;
            this.$router.push("/login");
            return false;
          }
        })
        .catch((e) => {
          this.$parent.user.authenticated = false;
          this.$router.push("/login");
          return false;
        });
    },
    manageOpenGroup() {
      let options = this.$localStorage.get("_employee_dashboard_options");
      if (options) {
        try {
          let optionsObj = JSON.parse(options);
          this.menuItemsBCRMChecked =
            this.menuItemsBCRM.length > 0 ? optionsObj.bcrm : false;
          this.menuItemseFWMChecked =
            this.menuItemseFWM.length > 0 ? optionsObj.fwm : false;
          this.menuItemsMMSChecked =
            this.menuItemsMMS.length > 0 ? optionsObj.mms : false;
        } catch (err) {
          this.menuItemsBCRMChecked = this.menuItemsBCRM.length > 0;
          this.menuItemseFWMChecked = this.menuItemseFWM.length > 0;
          this.menuItemsMMSChecked = this.menuItemsMMS.length > 0;
        }
      }

      //this.menuItemsBCRMChecked = false;
      //this.menuItemseFWMChecked = false;
      //this.menuItemsMMSChecked = false;

      //if (this.menuItemsBCRM.length > 0) {
      //  this.menuItemsBCRMChecked = true;
      //  this.menuItemseFWMChecked = false;
      //  this.menuItemsMMSChecked = false;
      //} else {
      //  if (this.menuItemseFWM.length > 0) {
      //    this.menuItemsBCRMChecked = false;
      //    this.menuItemseFWMChecked = true;
      //    this.menuItemsMMSChecked = false;
      //  } else {
      //    this.menuItemsBCRMChecked = false;
      //    this.menuItemseFWMChecked = false;
      //    this.menuItemsMMSChecked = true;
      //  }
      //}
    },
    saveFilterToLocal() {
      if (this.$refs.bcrm_checkbox != null)
        this.menuItemsBCRMChecked = this.$refs.bcrm_checkbox.checked;
      if (this.$refs.fwm_checkbox != null)
        this.menuItemseFWMChecked = this.$refs.fwm_checkbox.checked;
      if (this.$refs.mms_checkbox != null)
        this.menuItemsMMSChecked = this.$refs.mms_checkbox.checked;

      this.$localStorage.set(
        "_employee_dashboard_options",
        JSON.stringify(this.dashboardOptionsObj)
      );
    },
  },
};
